const points = [
  { icon: 'ri-ear-line', text: "Écoute attentive de vos besoins et de votre contexte" },
  { icon: 'ri-search-line', text: "Analyse approfondie de la situation et des enjeux" },
  { icon: 'ri-lightbulb-line', text: "Solutions concrètes et personnalisées à votre activité" },
  { icon: 'ri-check-double-line', text: "Accompagnement dans la mise en œuvre" },
];

export default function ApproachSection() {
  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#1A2B4A] mb-3">
              Notre méthode
            </p>
            <h2 className="font-poppins text-3xl lg:text-4xl font-semibold text-[#1A2B4A] mb-5">
              Notre Approche
            </h2>
            <div className="w-12 h-0.5 bg-[#1A2B4A] mb-8"></div>
            <p className="text-gray-600 text-sm leading-relaxed mb-8">
              Chaque mission est réalisée avec sérieux et méthode afin de proposer
              des solutions concrètes et adaptées aux besoins du client. L'objectif
              est d'apporter des résultats mesurables et durables.
            </p>
            <ul className="flex flex-col gap-4">
              {points.map((item, i) => (
                <li key={i} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-white text-[#1A2B4A] flex-shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <span className="text-gray-700 text-sm">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="w-full h-[480px] rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/090c56bb2fb8aee0ea24a1f82ab0d329.jpg"
                alt="Approche professionnelle SOMINKA Bordeaux"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute top-6 left-6 bg-white rounded-md px-4 py-2">
              <span className="text-xs font-semibold text-[#1A2B4A] tracking-wide">
                Bordeaux, France
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
